import styled from "styled-components";

const Description = styled.p`
  color: #ffffff;
  font-size: 1.5rem;
  line-height: 1.25;
  margin: 0;
  padding: 0;

  @media (max-width: 576px) {
    font-size: 20px;
  }
`;

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description/index.jsx